import React from 'react'

export default function StructureRow({ symbol, label }) {
  return (
    <div className="structureRow">
      <div className={symbol + ' structureSymbol'}>{symbol}</div>
      <div className="structureLabel">
        <div>{label}</div>
        <div className="disabled-caption">w złotych, w tysiącach</div>
      </div>
    </div>
  )
}
